import { Utils } from "@/plugins/utils";
import router from '@/router';
import moment from "moment";

export default {
	namespaced: true,
	state: {
		lstCo1: [],
		co1: null,
		loading: false,
		itemsPerPage: 20,
		search: "",
		hasNext: false,
		since: moment().format("YYYY-MM-DD 00:00"),
		until: moment().format("YYYY-MM-DD 23:59"),
		lstCo2: [],
		cf6: null,
		lstCo2Confirmed: []
	},
	getters: {
		co1model(state){
			let co1 = state.co1
			co1.lstCo2 = state.lstCo2Confirmed
			return co1
		},
		salesAmountConfirmed(state){
			let amount = 0
			const salesAmount = (accumulator, item) => accumulator + item.cv5totalnf
			amount += state.lstCo2Confirmed.reduce(salesAmount, amount)
			return amount
		},
		salesAmount(state){
			let amount = 0
			const salesAmount = (accumulator, item) => accumulator + item.cv5totalnf
			amount += state.lstCo2.reduce(salesAmount, amount)
			return amount
		},
		commissionAmountConfirmed(state){
			let amount = 0
			const commissionAmount = (accumulator, item) => accumulator + item.commissionValue
			amount += state.lstCo2Confirmed.reduce(commissionAmount, amount)
			return amount
		},
		commissionAmount(state){
			let amount = 0
			const commissionAmount = (accumulator, item) => accumulator + item.commissionValue
			amount += state.lstCo2.reduce(commissionAmount, amount)
			return amount
		},
	},
	mutations: {
		set(state, co1){
			state.co1 = co1
			state.lstCo2 = co1.lstCo2
		},
		initForm(state){
			state.co1 = {co1frete: false}
			state.lstCo2 = []
			state.lstCo2Confirmed = []
		},
		setParamsDataTable(state, payload){
			state.lstCo1 = payload.items
			state.itemsPerPage = payload.limit
			state.hasNext = payload.hasNext
		},
	},
	actions: {
		initForm(store){
			store.commit("initForm")
		},
		async findCommissionSales(store){
			let co1inicio = store.state.co1.co1inicio
			let co1fim = store.state.co1.co1fim
			let co1frete = store.state.co1.co1frete ?? false
			
			if(!co1inicio)
				co1inicio = moment('1899-12-30').format("YYYY-MM-DDT00:00")

			if(!co1fim)
				co1fim =  moment().format("YYYY-MM-DDT23:59")

			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Pesquisando vendas...", indeterminate: true }, {root: true})
			let payload = await this._vm.$axios.get(`/Representative/CommissionClosing/FindCommissionSales?co1repres=${store.state.co1.co1repres}&co1inicio=${co1inicio}&co1fim=${co1fim}&co1frete=${co1frete}`)
			.then(response => {
				let lstCo2 = Utils.ValidateAxiosResponse(response.data);
				let id = 1
				for (const co2 of lstCo2) {
					co2.selected = true
					co2.id = id
					id++
				}
				store.state.lstCo2 = lstCo2
				store.state.lstCo2Confirmed = lstCo2
				
				return true
			})
			.catch((error) => {
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return false
			});
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, {root: true})

			return payload
		},
		async close(store){
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Fechando comissão", indeterminate: true }, {root: true})

			if(!store.state.co1.co1inicio)
				store.state.co1.co1inicio = moment('1899-12-30').format("YYYY-MM-DDT00:00")

			if(!store.state.co1.co1fim)
				store.state.co1.co1fim =  moment().format("YYYY-MM-DDT23:59")

			if (!store.state.co1.co1fecha) {
				store.state.co1.co1fecha = await store.dispatch("dictionary/getNextNumber", "co1fecha", { root: true })
			}

			let pauload = await this._vm.$axios.post("/Representative/CommissionClosing/Close", store.getters.co1model )
			.then(response => {
				let relatPath = Utils.ValidateAxiosResponse(response.data);

                if(relatPath)
                    store.dispatch("print/openRelatsPath", [ relatPath ], { root: true })

				router.push("/oryxpdv/fechamentos-comissao")
				store.state.co1 = null
				store.state.lstCo2 = []
				store.state.lstCo2Confirmed = []
				return true
			})
			.catch((error) => {
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return false
			});
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, {root: true})
			return pauload
		},
		async deleteCommissionSale(store, co2){
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Excluíndo venda do fechamento de comissão", indeterminate: true }, {root: true})
			let payload = await this._vm.$axios.delete(`/Representative/CommissionClosing/DeleteCommissionSale/${co2.co2fecha}/${co2.co2doc}/${co2.co2tipo}/${co2.co2emissor}`)
			.then(response => {
				Utils.ValidateAxiosResponse(response.data);
				store.dispatch("find", store.state.co1.co1fecha)
				return true
			})
			.catch((error) => {
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message,
				}, { root: true })
				return false
			});
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, {root: true})
			return payload
		},
		async search(store, { limit = 20, page = 1, orderBy = "DESC"}){
			store.state.loading = true
			store.commit("initForm")

			let url = `/Representative/CommissionClosing/Search?search=${store.state.search}&limit=${limit}&page=${page}&orderBy=${orderBy}`
			if (store.state.since) {
				url+= `&since=${store.state.since}`
			}
			if (store.state.until) {
				url+= `&until=${store.state.until}`
			}

			let payload = await this._vm.$axios.get(url)
			.then(response => {
				let payload = Utils.ValidateAxiosResponse(response.data);
				store.commit("setParamsDataTable", payload)
				return true
			})
			.catch((error) => {
				store.state.lstCo1 = []
				store.state.search = ""
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return false
			});
			store.state.loading = false
			return payload
		},
		async find(store, co1fecha){
			store.state.loading = true
			store.commit("initForm")
			let payload = await this._vm.$axios.get(`/Representative/CommissionClosing/Find/${co1fecha}`)
			.then(response => {
				let co1 = Utils.ValidateAxiosResponse(response.data);
				store.commit("set", co1)
				return true
			})
			.catch((error) => {
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return false
			});
			store.state.loading = false
			return payload
		},
		async printReportCommissionClose(store, co1fecha ){
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Imprimindo fechamento de comissão", indeterminate: true }, {root: true})

			let payload = await this._vm.$axios.get("/Representative/CommissionClosing/PrintReportCommissionClose/"+ co1fecha)
			.then(response => {
				let relatPath = Utils.ValidateAxiosResponse(response.data);

                if(relatPath)
                    store.dispatch("print/openRelatsPath", [ relatPath ], { root: true })
					
				return true
			})
			.catch((error) => {
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return false
			});
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, {root: true})

			return payload
		}
	}
}